import { useEffect } from 'react';
import useSWR from 'swr';
import { EngineService } from '@/services/engine';
import { useSourcesStore } from '@/stores';
import { getSourceCacheKey } from '@/constants/cache-keys';
import { isAnalyzingSourceStatus } from '@/features/SourceView/sourceStatusDisplay';

export function useResolvedSource(sourceId?: string) {
    const getSourceById = useSourcesStore((state) => state.getSourceById);
    const addSource = useSourcesStore((state) => state.addSource);

    const source = sourceId ? getSourceById(sourceId) : undefined;
    const { data: fetchedSource } = useSWR(
        sourceId && !source ? getSourceCacheKey(sourceId) : null,
        () => EngineService.getSource(sourceId!),
        { revalidateOnFocus: false },
    );

    useEffect(() => {
        if (fetchedSource) {
            addSource(fetchedSource);
        }
    }, [fetchedSource, addSource]);

    const resolvedSource = source ?? fetchedSource;
    const sourceReady = resolvedSource !== undefined;
    const sourceIsAnalyzing =
        resolvedSource?.status !== undefined &&
        isAnalyzingSourceStatus(resolvedSource.status);

    return { resolvedSource, sourceReady, sourceIsAnalyzing };
}
